import { useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";
import { useSelector } from "react-redux";
// material
import { styled } from "@mui/material/styles";
import { Card, CardHeader } from "@mui/material";
import { getResearchExtensionMentor } from "../../core/service/researchExtension.service";

// ----------------------------------------------------------------------

const CHART_HEIGHT = 372;
const LEGEND_HEIGHT = 72;

const ChartWrapperStyle = styled("div")(({ theme }) => ({
  height: 300,
  marginTop: theme.spacing(5),
  "& .apexcharts-canvas svg": { height: CHART_HEIGHT },
  "& .apexcharts-canvas svg,.apexcharts-canvas foreignObject": {
    overflow: "visible"
  },
  "& .apexcharts-legend": {
    height: LEGEND_HEIGHT,
    alignContent: "center",
    position: "relative !important",
    borderTop: `solid 1px ${theme.palette.divider}`,
    top: `calc(${CHART_HEIGHT - LEGEND_HEIGHT}px) !important`
  }
}));

// ----------------------------------------------------------------------

export default function ResearchPeriodExtensionChartMentor() {
  const [listResearchExtension, setListResearchExtension] = useState([{}]);
  const { user: currentUser } = useSelector((state) => state.authReducer);
  const { id } = currentUser;
  const researchExtensionn = async () => {
    const data = await getResearchExtensionMentor(id);
    const { entities: researchExtensions } = data;
    setListResearchExtension(researchExtensions);
  };
  const stdPostDoc =
    [
      ...new Set(
        listResearchExtension
          ?.filter((e) => e.role_id === 1)
          .reduce((acc, e) => {
            acc.push(e.user_id);
            return acc;
          }, [])
      )
    ].length || 0;
  const stdPhd =
    [
      ...new Set(
        listResearchExtension
          ?.filter((e) => e.role_id !== 1)
          .reduce((acc, e) => {
            acc.push(e.user_id);
            return acc;
          }, [])
      )
    ].length || 0;

  useEffect(() => {
    researchExtensionn();
  }, []);
  const CHART_DATA = [stdPostDoc, stdPhd];
  
  const chartOptions = {
    colors: ["#0070C0", "#1CD1A1"],
    dataLabels: {
      enabled: false,
      formatter: (val) => val,
      dropShadow: { enabled: false }
    },
    labels: ["Post doc", "Phd"],
    plotOptions: {
      pie: {
        donut: {
          labels: {
            show: true,
            total: {
              show: true,
              label: "Total",
              color: "#373d3f",
              formatter: (val) => {
                return val.globals.seriesTotals.reduce((a, b) => {
                  return a + b;
                }, 0);
              }
            }
          }
        }
      }
    },
    legend: { show: false }
  };

  return (
    <Card>
      <CardHeader title="Research Period Extension" />
      <ChartWrapperStyle dir="ltr">
        <ReactApexChart
          type="donut"
          series={CHART_DATA}
          options={chartOptions}
          height={280}
        />
      </ChartWrapperStyle>
    </Card>
  );
}
